<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          DEPARTMENT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Department' : 'Create New Department' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="clear">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Name"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Name</label>
                  <v-text-field
                    id="name"
                    single-line
                    outlined
                    placeholder="Name"
                    dense
                    v-model="items.name"
                    required
                    :error-messages="errors"
                    :success="valid"
                    class="px-5"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Head"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Head</label>
                  <v-text-field
                    id="head"
                    single-line
                    outlined
                    placeholder="Head"
                    dense
                    v-model="items.head"
                    required
                    :error-messages="errors"
                    :success="valid"
                    class="px-5"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Head Email"
                  rules="required|email"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Head Email</label>
                  <v-text-field
                    id="head-email"
                    single-line
                    outlined
                    placeholder="Head Email"
                    dense
                    v-model="items.head_email"
                    required
                    :error-messages="errors"
                    :success="valid"
                    class="px-5"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Division"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Division</label>
                  <v-autocomplete
                    id="division"
                    single-line
                    outlined
                    placeholder="Select Division"
                    dense
                    v-model="items.divisi_id"
                    required
                    :error-messages="errors"
                    :success="valid"
                    class="px-5"
                    :items="itemsDiv"
                    item-value="id"
                    item-text="name"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="House"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">House</label>
                  <v-autocomplete
                    id="house"
                    single-line
                    outlined
                    dense
                    label="Select House"
                    v-model="items.house_id"
                    required
                    multiple
                    :error-messages="errors"
                    :success="valid"
                    class="px-5"
                    :items="itemsHouse"
                    item-value="id"
                    item-text="name"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Description"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Description</label>
                  <v-textarea
                    id="desc"
                    single-line
                    outlined
                    placeholder="Descripton"
                    v-model="items.desc"
                    required
                    data-vv-name="desc"
                    class="px-5"
                    :success="valid"
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'department' }"
                  >Cancel</v-btn
                >
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="save()"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  data() {
    return {
      items: {
        name: '',
        desc: '',
        divisi_id: null,
        head: '',
        head_email: '',
        house_id: []
      },
      loading: true,
      progressDialogLoading: true,
      search: '',
      itemsDiv: [],
      itemsHouse: [],
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Department List',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: this.id ? 'Edit' : 'Create',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    this.getDivision();
    this.getHouse();
    if (this.id) {
      this.getDetail();
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 800);
    }
  },
  methods: {
    getDivision() {
      const limit = 100;
      this.$store
        .dispatch('division/getAll', { limit })
        .then(data => {
          if (data.code === 200) {
            this.itemsDiv = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getHouse() {
      this.$store
        .dispatch('advanceFilter/getHouse')
        .then(data => {
          if (data.code === 200) {
            this.itemsHouse = data.data.result.filter(val => {
              return val.type === 'house';
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('department/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.items.house_id = data.data.result.connection.map(item => {
              return item.house_id;
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async clear() {
      this.items = {
        name: '',
        desc: '',
        divisi_id: null,
        head: '',
        head_email: ''
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.id) {
          this.$store
            .dispatch('department/update', { id: this.id, params: this.items })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'department'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch('department/create', this.items)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'department'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>
